'use strict';

// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').factory('PeriodSelectService', function(filterFilter, $uibModal) {
  return {
    openPeriodSelection: function(period, filters) {
      const modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'views/periodo_select/rangeDateSelect.html',
        controller: 'PeriodSelectionModalCtrl',
        windowClass: 'period-select-modal',
        resolve: {
          period: function() {
            return period;
          },
          filters: function() {
            return filters;
          }
        }
      });

      modalInstance.opened.then(function() {
        const modalEl = document.querySelector('.period-select-modal');
        if (!modalEl) {
          return;
        }
        const stopProp = function(e) {
          e.stopPropagation();
        };
        modalEl.addEventListener('click', stopProp);
        modalInstance.result.finally(function() {
          modalEl.removeEventListener('click', stopProp);
        });
      });

      return modalInstance.result;
    },

    getFilterPeriodo: function(safras) {
      const safraAtual = filterFilter(safras, { current: true })[0];
      const safraAnterior = safras[safras.indexOf(safraAtual) - 1];
      const safraObject = function(safra, descricao) {
        safra = safra || {};

        const dataFinal = moment(safra.data_final || new Date()).startOf('day');

        const dataInicial = safra.id ? moment(safra.data_inicial).startOf('day') :
          moment().subtract(30, 'days')
            .startOf('day');

        return {
          id: safra.id || null,
          dataFinalFormat: dataFinal.format(MOMENT_DATE_ENGLISH_FORMAT),
          descricao,
          dataInicial,
          dataFinal
        };
      };
      const ret = [safraObject(null, 'Últimos 30 Dias')];

      if (safraAtual) {
        ret.push(safraObject(safraAtual, 'Safra Atual'));
      }

      if (safraAnterior) {
        ret.push(safraObject(safraAnterior, 'Safra Anterior'));
      }

      return ret;
    }
  };
});
